import {
  MaterializedItemTaskDocument,
  MaterializedItemTaskQueryVariables,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type WorkflowOwner = {
  id: string
  firstName: string
  lastName: string
  fullName: string
  employee?: {
    preferredName?: string | null
    canSharePreferredName: boolean
  } | null
}

export const useMaterializedTaskItem = (variables: MaterializedItemTaskQueryVariables) => {
  const { data, loading } = useQuery(MaterializedItemTaskDocument, { variables })

  const materializedItem = data?.processes.materializedItemsConnection.nodes?.[0]
  const materializedStep = materializedItem?.materializedStep

  const stepName = materializedStep?.name ?? '-'
  const mandatory = materializedItem?.item?.taskConfiguration?.mandatory ?? false

  const access = materializedStep?.materializedProcess?.resourceRelationships?.at(0)?.access

  const workflowOwner: WorkflowOwner | undefined = access
    ? {
        id: access.id,
        firstName: access.firstName,
        lastName: access.lastName,
        fullName: access.fullName,
        employee: access.employee
          ? {
              preferredName: access.employee.preferredName,
              canSharePreferredName: access.employee._policies?.sharePreferredName.can ?? false,
            }
          : null,
      }
    : undefined

  return {
    workflowOwner,
    stepName,
    mandatory,
    loading,
  }
}
